module.exports = __webpack_public_path__ + "img/img8.4071ae24.png";